import { render, staticRenderFns } from "./ImagePreviewFrame.vue?vue&type=template&id=e1d82ff6&scoped=true&"
import script from "./ImagePreviewFrame.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewFrame.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewFrame.vue?vue&type=style&index=0&id=e1d82ff6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d82ff6",
  null
  
)

export default component.exports